import { putUsersPreferencesPipeSeries } from "@imi/api-client/index.js";
import { CustomPipeSeries } from "@src/core/api/customPipeSeries";
import { PipeSeriesPreference } from "@src/core/api/pipeSeriesPreference";
import { extractDefaultValues } from "@src/core/engine/helpers/extractDefaultValues";
import { pipesRepository } from "@src/core/engine/pipes/pipesRepository";
import { setUnchangedToNull } from "@src/shared/helpers/setUnchangedToNull";
import { tryit } from "radashi";

export async function updatePipeSeriesPreference(
  pipeSeriesPreference: PipeSeriesPreference,
  customSeries: CustomPipeSeries[],
) {
  const selectedCustomSeries = customSeries.find(
    (series) => series.id === pipeSeriesPreference.pipeSeries,
  );

  if (selectedCustomSeries) {
    if (!pipeSeriesPreference.pipeSeries || !pipeSeriesPreference.pipes) {
      return [
        new Error("Missing required fields for custom pipe series preference"),
      ];
    }

    const selectedCustomPipe = !selectedCustomSeries.pipes.some(
      (pipe) => pipe.id === pipeSeriesPreference.pipes,
    );
    if (selectedCustomPipe && pipeSeriesPreference.pipes !== "all") {
      return [
        new Error("The selected pipe is not in the selected custom series"),
      ];
    }

    return tryit(putUsersPreferencesPipeSeries)({
      body: {
        pipeId:
          pipeSeriesPreference.pipes === "all"
            ? null
            : pipeSeriesPreference.pipes,
        pipeSeriesId: pipeSeriesPreference.pipeSeries,
        pipeSeriesSource: "custom",
      },
    });
  }

  const definitions = pipesRepository.getDefinitions();
  const cleanedValues = setUnchangedToNull(
    pipeSeriesPreference,
    extractDefaultValues(definitions),
  );
  return tryit(putUsersPreferencesPipeSeries)({
    body: {
      pipeId: cleanedValues.pipes,
      pipeSeriesId: cleanedValues.pipeSeries,
      pipeSeriesSource: "engine",
    },
  });
}
